export const LAMBDAS = 
[
"AcceptOrDeleteCodes",
"AchiCodebookIndex",
"AchiCodebookIndex_v13",
"AdminConfirmationUserACS",
"Audit_screen_get_queue_data",
"Audited_screen_workflow_get_dashboard_data",
"Code_Workflow_Coders_API_acs_v1",
"CoderStatsDownload",
"CoderStatsFilters",
"CoderStats",
"CodersList",
"CodersSearch",
"CodesAssignedFilter",
"CodingStatsDownload",
"CodingStatsFilters",
"CodingStats",
"CodingSupportGetFilters",
"CodingSupportHealthFundContract",
"CodingSupportMRNSearchFilter",
"CodingSupportQueue",
"CodingSupportSpecialitySearchFilter",
"ConfirmAndRestpassword",
"DaysofOutstandingFilter",
"DeleteAdminOrganizations",
"DrgAlosFilter",
"DrgDescriptionFilter",
"DrgFilter",
"DrgOutliersReportDownload",
"DrgOutliersReportFilters",
"DrgOutliersReport",
"Drg_Outliers_Report_Download",
"Drg_Outliers_Report",
"EpisodeAssignmentCodeWorkflow",
"ErrorDrgCodeFilter",
"ErrorDrgDescription",
"ErrorDrgEpisodeTypeFilter",
"ErrorDrgNwauFilter",
"ErrorDrgPdxFilter",
"ErrorDrgReportDownload",
"ErrorDrgReportFilters",
"ErrorDrgReport",
"Error_Drg_Report_Download",
"Error_Drg_Report",
"Filter_navigation_acs",
"ForgotPasswordApiAcs",
"GetUnacceptableUsersACS",
"HacCodeFilter",
"HacDescriptionFilter",
"HacNwauFilter",
"HacReportDownload",
"HacReportFilters",
"HacReport",
"HacRevenueFilter",
"Hac_Report_Download",
"Hac_Report",
"LowerBoundFilter",
"OutstandingPatientIdFilter",
"OutstandingReportDownload",
"OutstandingReport",
"PostAdminOrganizations",
"PostAdminRolesACS",
"PrincipalDiagnosisCodeFilter",
"RejecteUserRequestACS",
"RevenueFilter",
"SAML_integration_API",
"Sam_priority_get_data",
"San_Enhance_findings_dashboard_api",
"San_health_fund_get_filters_him",
"San_health_fund_get_filters",
"San_los_get_filters",
"San_medical_record_number_filter",
"San_queue_data_and_filters",
"SaveUnconfirmedCodes",
"UpperBoundFilter",
"UserLeaveAllocation",
"UserLeaveCancel",
"UserLeaveUpdation",
"UserWorkAssignmentAllocationUpdation",
"UsersOnLeavePast",
"UsersOnLeaveSearch",
"UsersOnLeaveToday",
"UsersOnLeave",
"UsersWorkAssignedSearch",
"UsersWorkAssigned",
"WeightFilter",
"accept_delete_code_acs_beta_code_assist",
"accept_delete_codes_beta_acs",
"achi_codebook_tabular",
"achi_codebook_tabular_v13",
"acs_Live_api_monitoring",
"acs_coding_allocation_count",
"acs_download_code_reference",
"acs_monitoring_websocket_api_url",
"add_audit_comment_ics_v1",
"adminRoleModulePermissionsACS",
"admin_confirmation_users",
"admin_login_users_acs",
"admin_login_users",
"admin_login_users_mfa",
"admin_role_module_permissions",
"ai_agent_hcs",
"assignment_modal",
"audit_queue_data",
"auditor_priority_filters_acs",
"auditor_queue_filters_acs",
"auditor_rule_selection_checkboxes",
"auditor_screen_edit_acs",
"auditor_screen_status_change",
"auditor_speciality_filters_acs",
"auditor_status_filters_acs",
"auditor_workspace_cards",
"auditor_workspace_episode_data",
"auditor_workspace_queues",
"auditor_workspace_stats",
"call_glue_job_data_validation_ics_v1",
"call_glue_job_work_flow_tool_ics_v1",
"carddataforSANdashboard",
"change_password_ics_v1",
"checkForCofAcs",
"checkIfCodeExists",
"check_for_cof_acs_beta_code_assist",
"check_if_code_exists_beta_code_assist",
"check_if_code_exists_beta",
"check_user_has_code_accelerate_assist_permission",
"codeAdviceSearch",
"codeRecommendation",
"codeWorkflowMrnsearchRecommendation",
"code_assist_cancer_warnings",
"code_assist_dcid_warnings",
"code_assist_rules_engine",
"code_recommendation_acs_beta_code_assist",
"code_recommendation_acs_beta",
"code_workflow_episode_assignment",
"code_workflow_him_workspace",
"codebookIndex5",
"codebookIndex6",
"codebook_acs",
"codebook_acs_v13",
"coder_queue_filters_acs",
"coder_workspace_cards",
"coder_workspace_episode_data",
"coder_workspace_queues",
"coder_workspace_stats",
"codie_achi_agent",
"codie_adx_agent",
"codie_pdx_agent",
"codingScreenAcceptOrDeleteCodes",
"coding_improvements_data_v1_ics_v1",
"coding_screen_get_queue_data",
"coding_screen_status_update",
"coding_screen_workflow_get_dashboard_data_bysearch",
"coding_screen_workflow_get_dashboard_data",
"coding_screen_workflow_urnumber_filters_data",
"coding_support_awaiting_cdq",
"coding_support_cards_data",
"coding_support_episode_assignment",
"coding_support_episode_data",
"coding_support_missing_notes",
"coding_support_queue_filters_acs",
"coding_support_stats",
"coding_support_stats_queue_data",
"confirmAndRestpassword_ics_v1",
"deleteAdminCountriesACS",
"deleteAdminModules",
"deleteAdminRolesACS",
"delete_admin_countries",
"delete_admin_modules",
"delete_admin_organizations",
"delete_admin_roles",
"download_audit_files_work_flow_tool_ics_v1",
"download_user_feedback_attachment_ics_v1",
"drg_error_rate_calculation_v1",
"drg_filter_options_acs",
"drg_grouping_additional_information",
"drg_optimisation_v1",
"drg_options",
"drgchangecountSANapiv1",
"episode_assignment_code_workflow",
"episode_assignment_coding_support",
"episode_assignment_v1",
"episode_details_ics_v2",
"episode_edit_ics_v1",
"episode_identifier_options_acs",
"export_audit_comment_ics_v1",
"export_csv_file_ics",
"export_url_link_for_download",
"feedback-form-signed-ics_v1",
"feedback_form_ics_v1",
"fields_acs",
"flag_unflag_episodes_ics_v1",
"flagged_episodes_ics_v2",
"flaggedepisodesSANv1",
"flaggedepisodesduplicatesSANv1",
"focus_area_data_v2_ics_v1",
"for_review_coders",
"forgotPasswordApi_ics_v1",
"getAdminCountriesACS",
"getAdminModulesACS",
"getAdminOrganizationsACS",
"getAdminRolesACS",
"getAdminUsersACS",
"getDrgCodesOrRecommendationsIcsV1",
"getEpisodeDataAcs",
"getEpisodeData",
"getUserRolesACS",
"get_admin_countries",
"get_admin_modules",
"get_admin_organizations",
"get_admin_roles",
"get_admin_users",
"get_audit_log",
"get_code_enhance_audit_changes",
"get_code_enhance_audit_current_episode_data",
"get_code_enhance_audit_diagnoses_codes",
"get_code_enhance_audit_result",
"get_coded_by_user_names_or_recommendations_ics_v2",
"get_coder_queues",
"get_current_drg_hcp_line_id",
"get_drg_code_acs",
"get_drg_history_details",
"get_episode_data_acs_beta_code_assist",
"get_episode_data_acs_beta",
"get_episode_queue_to_be_audit",
"get_episode_queue_user_data",
"get_files_for_power_bi_ics_v1",
"get_filter_options_ics_v2",
"get_filter_workflow_dashboard_v1",
"get_filters_pie_chart_v1",
"get_header_file_ics_v1",
"get_him_workspace",
"get_last_updated_at_or_recommendations_ics_v1",
"get_reference_id_or_recommendations_ics_v1",
"get_short_description_or_recommendations_ics_v1",
"get_unacceptable_users",
"get_uploaded_by_user_names_or_recommendations_ics_v1",
"get_user_names_or_recommendations_ics_v1",
"get_user_roles",
"glue_job_notification_ics_v1",
"hcp_data_filter_api_ics_v3",
"hcp_line_id_findings_api",
"hcp_line_missing_note_remove",
"hcp_lines_audit_change",
"hcp_lines_audit_data",
"hcsRedactedTextS3",
"him_auditors_filters_acs",
"him_coders_filters_acs",
"him_dashboard_beta",
"him_dashboard_get_filters_coding_manager_screen_bets",
"him_dashboard_get_filters_coding_manager_screen_queue",
"him_dashboard_get_filters_coding_manager_screen_users",
"him_dashboard_get_speciality_coding_manager",
"him_drg_filters_acs",
"him_episode_identifier_filters_acs",
"him_get_assign_queues",
"him_get_assign_users",
"him_get_queues_sidebar",
"him_get_users_sidebar",
"him_health_fund_get_filters_acs",
"him_mrn_filters_acs",
"him_priority_filters_acs",
"him_queue_filters_acs",
"him_speciality_filter_acs",
"him_speciality_filters_acs",
"him_status_filter_acs",
"him_status_filters_acs",
"him_workspace_auditor_episode_data",
"him_workspace_cards",
"him_workspace_episode_data",
"him_workspace_sidebar_queues",
"him_workspace_sidebar_users",
"home_navigation_update_acs",
"ics_codie_achi_agent_13th",
"ics_codie_adx_13th",
"ics_codie_pdx_13th",
"ics_llm_versions_ics_v1",
"index_codebook_acs",
"index_codebook_acs_v13",
"knowledge-base-au-codes-advice",
"lambda_genai_ics_v1",
"llm_archive_unarchive_ics_v1",
"llm_conversation_update_ics_v1",
"llm_delete_conversation_ics_v2",
"llm_get_conversations_ics_v2",
"llm_get_messages_ics_v1",
"llm_is_liked_ics_v1",
"llm_post_conversation_ics_v1",
"llm_post_messages_ics_v1",
"mfa_initiate_auth",
"mrn_filter_options_acs",
"ics_llm_get_conversations_ics_v2",
"mutlti_drg_prepare_response",
"outstanding_report_download",
"outstanding_report_filter",
"outstanding_report",
"pallas-genai-v3-lambda",
"pallas_algo_cdc",
"pallas_algo_episode_data",
"pallas_genai_v3_12th_edition",
"postAdminCountriesACS",
"postAdminModulesACS",
"postAdminRoleModulePermissions",
"postUserRolesACS",
"post_admin_countries",
"post_admin_modules",
"post_admin_organizations",
"post_admin_role_module_permissions",
"post_admin_roles",
"post_code_enhance_audit_changes",
"post_user-roles",
"power_app_add_audit_rule_ics_v1",
"power_app_add_category_ics_v1",
"power_app_get_audit_rule_by_ref_no_ics_v2",
"power_app_get_audit_rule_rows_ics_v1",
"power_app_list_category_ics_v1",
"power_app_update_audit_rule_ics_v1",
"power_bi_findings_data_ics_v1",
"power_bi_get_filter_ics_v1",
"rcm_overview_v3_ics_v1",
"refreshTocken",
"register_a_new_user_acs",
"register_a_new_user",
"rejecte_user_request",
"san_episodes_audited_speciality_filter",
"search_by_episode_identifier_ics_v2",
"search_by_episode_identifier_recommendation_ics_v3",
"send_to_auditor_options",
"setting_multi_drg_create",
"setting_multi_drg_delete_healthfund",
"setting_multi_drg_grouper_version_list",
"setting_multi_drg",
"setting_multi_drg_update",
"stats_audit_screen_workflow",
"stats_coding_screen_workflow",
"test_coder_assign_list",
"test_create_workflow_queue",
"test_delete_worklow_queue_rules",
"test_episode_assignment_code_workflow",
"test_get_queue_rules",
"test_get_workflow_queue_detail",
"test_get_workflow_queue",
"test_reasoning_coding",
"test_search_workflow_queue",
"test_workflow_queue_filter",
"unassignFunctionalityICSV1",
"unassignedEpisodesICSV1",
"unlock_episode",
"updateAdminCountriesACS",
"updateAdminModulesACS",
"updateAdminRolesACS",
"updateAdminZOrganizations",
"update_admin_countries",
"update_admin_modules",
"update_admin_organizations",
"update_admin_role_assign_acs",
"update_admin_roles_ics_v1",
"update_admin_roles",
"update_missing_notes_status",
"upliftforSANAPI",
"upload_hcp_files_to_s3_ics_v1",
"user_feedback_get_details_api_ics_v1",
"websocket_api_url",
"workflow_audit_screen_get_filters_queue_data",
"workflow_audit_screen_get_filters_speciality_data",
"workflow_audit_screen_get_filters_status_priority_data",
"workflow_audit_screen_get_filters_urnumber_data",
"workflow_check_job_status_s3_to_rds_ics_v1",
"workflow_coding_screen_get_filters_queue_data",
"workflow_coding_screen_get_filters_speciality_data",
"workflow_coding_screen_get_filters_status_priority_data",
"workflow_dashboard_fetch_files_ics_v1",
"RoleValidationACS"
]

